import React from 'react'
import Obfuscate from 'react-obfuscate'

const ContactData = () => (
    <div>
        <h4>Povpraševanja</h4>
        <p>Ivanci 16</p>
        <p>Bogojina, SI 9222, Slovenia</p>
        <p>
            <i className="fas fa-envelope" />
            <Obfuscate email="info@graficnistudio.net" />
        </p>
        <p>
            <a href="http://graficnistudio.net" target="_blank" rel="noopener noreferrer">
                <i className="fas fa-globe" />www.graficnistudio.net
            </a>
        </p>
        <h4 className="margin-top">Odpiralni čas</h4>
        <p>
            <i className="far fa-clock" />Ponedeljek - Petek 7 - 15
        </p>
        <p>
            <i className="fas fa-ban" />Sobota, nedelja in prazniki zaprto
        </p>
    </div>
)

export default ContactData



// WEBPACK FOOTER //
// ./src/components/ContactData.js